import styled from 'styled-components'

export const AbsoluteCenter = styled.div`
	position: fixed;
	text-align: center;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 9999;
`;

export const FloatingButtonContainer = styled.div`
	position: fixed;
	z-index: 9999;
	bottom: 32px;
	right: 64px;
`;

export const Form = styled.form`
	padding: 32px 32px;
`;

export const FormTitle = styled.div`
	font-size: 24px;
	border-bottom: 1px solid #878787;
`;

export const FormRow = styled.div`
	display: table;
	width: 100%;
`;


export const FormField = styled.div`
	box-sizing: border-box;
	padding-right: 32px;
	padding-top: 16px;
	width: ${props => props.width || 'auto'};
	display: inline-block;
	vertical-align: top;
`;


// WEBPACK FOOTER //
// ./src/components/StyledComponents.js